const areas = [
    "Los Angeles",
    "Long Beach",
    "Santa Ana",
    "Anaheim",
    "Irvine",
    "Glendale",
    "Huntington Beach",
    "Santa Clarita",
    "Garden Grove",
    "Lancaster",
    "Palmdale",
    "Pomona",
    "Torrance",
    "Pasadena",
    "Orange",
    "Fullerton",
    "El Monte",
    "Downey",
    "Costa Mesa",
    "Inglewood",
    "West Covina",
    "Norwalk",
    "Burbank", 
    "Compton",
    "South Gate",
    "Mission Viejo",
    "Carson",
    "Santa Monica",
    "Westminster",
    "Whittier",
    "Newport Beach",
    "Lakewood",
    "Buena Park",
    "Baldwin Park",
    "Lake Forest",
    "Tustin",
    "Bellflower",
    "Lynwood",
    "Redondo Beach",
    "Pico Rivera",
    "Montebello",
    "Huntington Park",
    "South Whittier",
    "Alhambra",
    "Monterey Park",
    "Gardena",
    "Diamond Bar",
    "Paramount",
    "Rosemead",
    "Arcadia",
    "Cerritos",
    "Glendora",
    "La Mirada",
    "Cypress",
    "Covina",
    "Azusa",
    "Bell Gardens",
    "Rancho Palos Verdes",
    "La Puente",
    "San Gabriel",
    "Culver City",
    "Monrovia",
    "Temple City",
    "Claremont",
    "Manhattan Beach",
    "Beverly Hills",
    "San Dimas",
    "Lawndale",
    "La Verne",
    "Walnut",
    "Diamond Bar",
    "San Fernando",
    "Calabasas",
    "Agoura Hills",
    "West Hollywood",
    "Santa Fe Springs",
    "San Marino",
    "Sierra Madre",
    "Hermosa Beach",
    "Lomita",
    "South Pasadena",
    "Hidden Hills",
    "Rolling Hills",
    "Palos Verdes Estates",
    "Malibu",
    "Signal Hill",
    "Commerce",
    "Bradbury", 
    "Maywood",
    "Duarte",
    "Lynwood",
    "Irwindale"
]

export default areas